import { createActions } from 'redux-actions';

import types from 'state/mrDistribution/shipments/actionTypes';

const { mrDistribution } = createActions({
  // [types.CHANGE_VALUES]: (values, shipmentKey = 0) => ({ values, shipmentKey }),
  [types.SET_SHIPMENT_KEYS]: ({ shipmentKeys }) => ({
    shipmentKeys,
  }),

  [types.changeTime$]: ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay = 0,
  }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay,
  }),

  [types.selectTime$]: ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay = 0,
  }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
    diffDay,
  }),

  [types.onBlurTimePicker$]: ({ stopType, timeParam, value, shipmentKey }) => ({
    stopType,
    timeParam,
    value,
    shipmentKey,
  }),

  [types.changeDate$]: ({ stopType, value, shipmentKey }) => ({
    stopType,
    value,
    shipmentKey,
  }),

  [types.changeAddress$]: ({ stopType, shipmentKey, address }) => ({
    stopType,
    shipmentKey,
    address,
  }),

  [types.cleanAddress$]: ({ shipmentKey, stopType }) => ({
    shipmentKey,
    stopType,
  }),

  [types.createShipment$]: ({ shipmentKey }) => ({
    shipmentKey,
  }),

  [types.ADD_SHIPMENT]: ({ shipmentKey }) => ({
    shipmentKey,
  }),

  [types.REMOVE_SHIPMENT]: ({ shipmentKey }) => ({
    shipmentKey,
  }),
});

export default mrDistribution;
